import { RepairOrderQuoteItems } from '../form-state';
import { useRepairOrderQuotesStore } from './repair-order-quotes-context';
import { RepairOrderQuoteStatusEnum } from 'api-new/generated';
import { InlineSvg } from 'components/svg';
import { useRecordStore } from 'features/vhc/model';
import { useFormContext } from 'react-hook-form';

export const ActionButtons = () => {
  const { isEditMode } = useRepairOrderQuotesStore();
  const { watch } = useFormContext<RepairOrderQuoteItems>();

  const { generalData } = useRecordStore();

  const items = watch('items');

  const canSave = items?.some((x) => x.status == RepairOrderQuoteStatusEnum.Created) ?? false;
  return (
    <>
      <button onClick={() => console.log()} className="btn btn-light-secondary" type="button">
        <InlineSvg path="/media/icons/custom/parcel-tracking.svg" className="svg-icon-2" />
        Manage parts
      </button>
      <button
        className="btn btn-light-primary"
        type={'submit'}
        disabled={!canSave || generalData?.soHeaderClosed === true}
      >
        <InlineSvg path="/media/icons/custom/pencil.svg" className="svg-icon-2" />
        {!isEditMode ? 'Edit Quote' : 'Save Changes'}
      </button>
    </>
  );
};
